import { Lightning, Gift } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export default function QuotaBadge({ user }) {
  const navigate = useNavigate();
  const q = user?.quota;
  if (!q) return null;

  const pct = q.tests_limit > 0 ? Math.min(100, Math.round((q.tests_used / q.tests_limit) * 100)) : 0;
  const isTrial = q.plan_code === "trial";
  const bonusBalance = q.bonus?.balance || 0;
  const overQuota = q.tests_used >= q.tests_limit && !isTrial;
  const warning = pct >= 80 && !overQuota;
  const exhausted = isTrial && q.tests_used >= q.tests_limit && bonusBalance <= 0;

  let bg = "bg-[#56A3F5]/10";
  let fg = "text-[#1B4FD8]";
  if (exhausted) { bg = "bg-red-100"; fg = "text-red-700"; }
  else if (overQuota) { bg = "bg-amber-100"; fg = "text-amber-800"; }
  else if (warning) { bg = "bg-amber-50"; fg = "text-amber-700"; }

  const limitLabel = q.tests_limit >= 9999 ? "∞" : q.tests_limit;
  const planLabel = isTrial ? "mensili" : "analisi";

  return (
    <button
      onClick={() => navigate("/pricing")}
      data-testid="quota-badge"
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-all hover:opacity-90 ${bg}`}
      title={`Piano ${q.plan_name}${q.overage_count ? ` · +${q.overage_count} overage` : ""}${bonusBalance > 0 ? ` · ${bonusBalance} omaggio` : ""}`}
    >
      <Lightning size={16} weight="duotone" className={fg} />
      <span className={`text-sm font-semibold ${fg}`}>
        {q.tests_used}/{limitLabel}{isTrial ? " " + planLabel : " analisi"}
        {q.overage_count > 0 && <span className="ml-1 text-xs">(+{q.overage_count})</span>}
      </span>
      {bonusBalance > 0 && (
        <span className="flex items-center gap-1 pl-2 ml-1 border-l border-current/20 text-emerald-700"
              data-testid="quota-bonus-pill">
          <Gift size={14} weight="duotone" />
          <span className="text-sm font-semibold">+{bonusBalance} omaggio</span>
        </span>
      )}
    </button>
  );
}
